import BaseApiService from './api.base.service'

class CoursesApi extends BaseApiService {
  constructor() {
    super('courses')
  }

  getTrainingCourseTypes() {
    return this.callGet('/types/training')
  }

  getPartecipantElearningCoursesOdata(params) {
    return this.callGet(`/elearning/list/odata`, params)
  }

  associatePartecipantToCourse(associateCourseData) {
    return this.callPost('partecipant/associate', associateCourseData)
  }

  getFruitionsSummary() {
    return this.callGet('/fruitions/summary')
  }
}

export const coursesApi = new CoursesApi()
